import Code from '@tiptap/extension-code';
import { Focus } from '@tiptap/extensions';
import { StarterKit } from '@tiptap/starter-kit';
import { OrderedList } from '@tiptap/extension-list';
import { TextStyle } from '@tiptap/extension-text-style';
import TableOfContents from '@tiptap/extension-table-of-contents';
import Document from '@tiptap/extension-document';

import Heading from './heading';
import FontSize from './font-size';
import NonBreakingSpaceOnSpace from './non-breaking-space-on-space';

// Custom Document that supports top-level block-instance nodes (docChild group)
export const CustomDocument = Document.extend({
  content: '(block | docChild)+',
});

// Standard Document for editors that don't use block-instances
export const StandardDocument = Document;

export const coreExtensions = [
  StarterKit.configure({
    heading: false,
    document: false,
    code: false,
    orderedList: false,
    trailingNode: {
      node: 'paragraph',
      notAfter: ['heading', 'blockquote', 'bulletList', 'orderedList', 'codeBlock'],
    },
  }),
  StandardDocument,
  Code,
  Heading,
  TextStyle,
  FontSize,
  OrderedList,
  Focus.configure({
    mode: 'all',
  }),
  TableOfContents.configure({
    anchorTypes: ['heading'],
  }),
  NonBreakingSpaceOnSpace,
];
